import classNames from 'classnames';
import { AnchorHTMLAttributes, MouseEvent } from 'react';
import { buildLeadChatUrl, isPlainLeftClick, tLeadChatTarget } from './LeadChat.functions';
import useOpenLeadChat, { toLeadChatModalLead } from './useOpenLeadChat.hook';

export type tLeadChatLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target'> & {
  chat: tLeadChatTarget;
};

/**
 * A real link to a lead's conversation (AGI-761). A plain click opens the chat
 * popup in place; a modifier or middle click, "open in new tab" and "copy link"
 * stay the browser's and land on `/workspace/chat`.
 *
 * `ph-no-capture`: the href carries the lead id, and replay masking does not
 * cover attributes.
 */
export default function LeadChatLink(props: tLeadChatLinkProps) {
  const { chat, className, onClick, children, ...anchorProps } = props;
  const openLeadChat = useOpenLeadChat();

  function handleClick(event: MouseEvent<HTMLAnchorElement>) {
    onClick?.(event);
    if (event.defaultPrevented || !isPlainLeftClick(event)) return;
    event.preventDefault();
    openLeadChat(toLeadChatModalLead(chat));
  }

  return (
    <a
      {...anchorProps}
      href={buildLeadChatUrl(chat)}
      className={classNames('ph-no-capture', className)}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
